module.exports = __webpack_public_path__ + "static/media/big-idoux.28fe2a5a.jpg";